import GrooveSearchResult from '@groove/api/visualforce/types/GrooveSearch/GrooveSearchResult';
import { StandardDropDownItem } from '@groove/ui/Components/DropDownItem';
import {
  ContactIcon,
  LeadIcon,
  BuildingIcon,
  LightbulbIcon,
  MoneyIcon,
  WarningIcon,
} from '@groove/ui/Components/BoogieIcon';
import { InfoIcon } from '@fluentui/react-icons-mdl2';
import { SearchUser } from '@groove/api/gateway/v1/users';
import { formatPhoneNumber } from '@groove/dialer-components/utils/phoneNumberUtils';

import { SFDC_USER_TYPES } from '../constants';

export const getSfdcTypeIcon = (type: string): JSX.Element => {
  switch (type) {
    case SFDC_USER_TYPES.CONTACT:
      return <ContactIcon className="text-neutral/900 w-[20px]" />;
    case SFDC_USER_TYPES.LEAD:
      return <LeadIcon className="text-neutral/900 w-[20px]" />;
    case SFDC_USER_TYPES.ACCOUNT:
      return <BuildingIcon className="text-neutral/900 w-[20px]" />;
    case SFDC_USER_TYPES.OPPORTUNITY:
      return <MoneyIcon className="text-neutral/900 w-[20px]" />;
    case SFDC_USER_TYPES.GROOVEUSER:
      return <InfoIcon className="text-neutral/900 w-[20px]" />;
    case SFDC_USER_TYPES.UNKNOWN:
      return <WarningIcon className="text-neutral/900 w-[20px]" />;
    default:
      return <LightbulbIcon className="text-neutral/900 w-[20px]" />; // new icon
  }
};

export const transformGrooveUserSearch = (
  user: SearchUser,
): StandardDropDownItem => {
  const { email, name, sfdc_user_id } = user;

  return {
    value: sfdc_user_id,
    key: sfdc_user_id,
    text: name || email,
    icon: getSfdcTypeIcon(SFDC_USER_TYPES.GROOVEUSER),
    secondaryText: name && email ? [email] : undefined,
    tooltip: 'Groove User',
    metaData: {
      email,
      name,
      type: SFDC_USER_TYPES.GROOVEUSER,
    },
  };
};

export const transformGrooveSearchWithPhoneNumber = (
  rawData: GrooveSearchResult,
): StandardDropDownItem => {
  const formatedPhoneNumber = formatPhoneNumber(rawData.Phone || '') ?? '';
  const result: StandardDropDownItem = {
    key: rawData.Id || '',
    text: rawData.Name || '',
    tooltip: undefined,
    value: rawData.Id || '',
    secondaryText: [formatedPhoneNumber],
  };

  return result;
};

const transformGrooveSearch = (
  rawData: GrooveSearchResult,
): StandardDropDownItem => {
  const result: StandardDropDownItem = {
    key: rawData.Id || '',
    text: '',
    tooltip: rawData.attributes.type || undefined,
    value: rawData.Id || '',
    icon: getSfdcTypeIcon(rawData.attributes.type || ''),
  };
  const joinTextArray = [];
  result.secondaryText = [] as string[];
  result.metaData = { type: rawData.attributes.type || '' };
  switch (rawData.attributes.type) {
    case SFDC_USER_TYPES.CONTACT:
    case SFDC_USER_TYPES.LEAD:
      result.text = rawData.Name || '<No Name>';

      if (rawData.Company) joinTextArray.push(rawData.Company);
      if (rawData.Email) {
        joinTextArray.push(rawData.Email);
        result.metaData.email = rawData.Email;
      }
      if (joinTextArray.length > 0)
        result.secondaryText.push(joinTextArray.join(' - '));

      if (rawData.Title) result.secondaryText.push(rawData.Title);

      return result;
    case SFDC_USER_TYPES.ACCOUNT:
      result.text = rawData.Name || '<No Name>';
      if (rawData.Industry) result.secondaryText.push(rawData.Industry);

      return result;
    case SFDC_USER_TYPES.OPPORTUNITY:
      joinTextArray.push(rawData.Name || '<No Name>');
      if (rawData.Account?.Name) joinTextArray.push(rawData.Account?.Name);
      result.text = joinTextArray.join(' - ');

      if (rawData.Type) result.secondaryText.push(rawData.Type);
      if (rawData.StageName) result.secondaryText.push(rawData.StageName);

      return result;
    default:
      result.text = rawData.Name || '<No Name>';
      result.secondaryText.push(`Type: ${rawData.attributes.type}`);
      return result;
  }
};

export default transformGrooveSearch;
